import { CoreLogService } from "../log.service";
import { Subject, ReplaySubject } from "rxjs";
import { Navigationtarget } from "./comEnvironmentEventsNavigationtarget";
import { environment } from "../../../../environments/environment";
import { YourAPPProductType } from "../../shared/contentTypes";
import { NgZone } from "@angular/core";

/** Plattformevents */

export interface Events {
  /** Zurücknavigieren (Zurückbutton im Browser, Android Zurückbutton)*/
  navigationBack: Subject<void>;

  /** DeviceReady */
  deviceReady: ReplaySubject<void>;

  /** Pausieren (wird ausgelöst wenn die Appausführung pausiert wird) */
  pause: Subject<void>;
  /** Fortsetzen (wird ausgelöst wenn die Webengine nach Pausierung (Beispielsweise wenn der native Wrapper auf Mobilgeräten in den Hintergrund gesetzt und wieder in den Vordergrund geholt wird) erneut aktiv wird) */
  resume: Subject<void>;

  /** Navigieren (wird ausgelöst wenn der Wrapper die Route ändern möchte) */
  navigate: Subject<Navigationtarget>;

  /** Device ist Online gegangen (wird ausgelöst wenn die App eine Verbindung mit dem Internet aufbaut) */
  online: Subject<void>;
  /** Device ist Offline gegangen (wird ausgelöst wenn die App eine Verbindung mit dem Internet verliert) */
  offline: Subject<void>;

  /** yourapp://customer.domain.de ist auferufen worden (wird ausgelöst wenn der Protokoll ausgelöst wird nur Android und iOS) */
  externIntent: Subject<string>;
}

/** Standardimplementierung */
export class EventsDefault implements Events {

  private _navigationBack: Subject<void> = new Subject<void>();
  private _resume: Subject<void> = new Subject<void>();
  private _pause: Subject<void> = new Subject<void>();
  private _navigate: Subject<Navigationtarget> = new Subject<Navigationtarget>();
  private _online: Subject<void> = new Subject<void>();
  private _offline: Subject<void> = new Subject<void>();
  private _externIntent: ReplaySubject<string> = new ReplaySubject<string>();
  private _deviceReady: ReplaySubject<void> = new ReplaySubject<void>();

  constructor(private _coreLogService: CoreLogService, private ngZone: NgZone) {
    const me = this;
    if (typeof document !== "undefined" && document) {
      document.addEventListener("deviceready", (ev) => me.ngZone.run(() => me.listenerDeviceready(ev)), false);
      document.addEventListener("backbutton", (ev) => me.ngZone.run(() => me.listenerBackbutton(ev)), false); // not on iOS
      document.addEventListener("resume", (ev) => me.ngZone.run(() => me.listenerResume(ev)), false);
      document.addEventListener("pause", (ev) => me.ngZone.run(() => me.listenerPause(ev)), false);
      document.addEventListener("online", (ev) => me.ngZone.run(() => me.listenerOnline(ev)), false);
      document.addEventListener("offline", (ev) => me.ngZone.run(() => me.listenerOffline(ev)), false);
      document.addEventListener("menubutton", (ev) => me.ngZone.run(() => me.listenerMenubutton(ev)), false); // not on iOS/Windows
      document.addEventListener("searchbutton", (ev) => me.ngZone.run(() => me.listenerSearchbutton(ev)), false); // not on iOS/Windows
      document.addEventListener("volumeupbutton", (ev) => me.ngZone.run(() => me.listenerVolumeupbutton(ev)), false); // not on iOS/Windows
      document.addEventListener("volumedownbutton", (ev) => me.ngZone.run(() => me.listenerVolumedownbutton(ev)), false); // not on iOS/Windows
    }
    // todo _navigate

    ///**
    // * Zurücknavigieren (Zurückbutton im Browser, Android Zurückbutton)
    // */

    ////TODO: Keine subscribe Methode ohne Router ? Ersteinmal jQuery benutzen
    ////me._location.subscribe(l => {
    ////    if (l.pop) {
    ////        me._navigationBack.next();
    ////    }
    ////});
    if (typeof window !== "undefined" && window) {
      window.addEventListener("batterycritical", (ev) => me.ngZone.run(() => me.listenerBatterycritical(ev)), false);
      window.addEventListener("batterylow", (ev) => me.ngZone.run(() => me.listenerBatterylow(ev)), false);
      window.addEventListener("batterystatus", (ev) => me.ngZone.run(() => me.listenerBatterystatus(ev)), false);
      // $(window).on("popstate", (ev) => me.ngZone.run(() => me.listenerBackbutton(ev)));
    }

    me.bindExternIntent();
  }

  private listenerDeviceready(ev) {
    const me = this;
    console.info("EventsDefault", "listenerDeviceready", ev);
    me._deviceReady.next();
  }
  private listenerMenubutton(ev) {
    console.info("EventsDefault", "listenerMenubutton", ev);
  }
  private listenerSearchbutton(ev) {
    console.info("EventsDefault", "listenerSearchbutton", ev);
  }
  private listenerVolumeupbutton(ev) {
    console.info("EventsDefault", "listenerVolumeupbutton", ev);
  }
  private listenerVolumedownbutton(ev) {
    console.info("EventsDefault", "listenerVolumedownbutton", ev);
  }
  private listenerBatterycritical(ev) {
    console.info("EventsDefault", "listenerBatterycritical", ev);
  }
  private listenerBatterylow(ev) {
    console.info("EventsDefault", "listenerBatterylow", ev);
  }
  private listenerBatterystatus(ev) {
    console.info("EventsDefault", "listenerBatterystatus", ev);
  }

  /** Zurücknavigieren (Zurückbutton im Browser, Android Zurückbutton) */
  public get navigationBack(): Subject<void> {
    return this._navigationBack;
  }

  /** DeviceReady */
  public get deviceReady(): ReplaySubject<void> {
    return this._deviceReady;
  }

  // @HostListener("$(window):popstate") and @HostListener("$(window):popstate")
  private listenerBackbutton(ev) {
    // matSelect button does not close by pressing backButton
    // close all overlays when pressing backButton will solve this problem
    const backDropElements = Array.from(document.getElementsByClassName("cdk-overlay-backdrop"));
    if (backDropElements.length > 0) {
      (backDropElements[0] as HTMLElement).click();
      // backDropElements.forEach(backDropElement => {
      //   (backDropElement as HTMLElement).click();
      // });
    } else if (this.navigationBack) {
      this.navigationBack.next();
    }
  }

  /** Fortsetzen (wird ausgelöst wenn die Appausführung fortgesetzt wird) */
  public get resume(): Subject<void> {
    return this._resume;
  }

  // @HostListener("document:resume")
  private listenerResume(ev: Event) {
    if (this.resume) {
      this.resume.next();
    }
  }

  /** Pausieren (wird ausgelöst wenn die Appausführung pausiert wird) */
  public get pause(): Subject<void> {
    return this._pause;
  }

  // @HostListener("document:pause")
  private listenerPause(ev: Event) {
    if (this.pause) {
      this.pause.next();
    }
  }

  /** Navigieren (wird ausgelöst wenn der Wrapper die Route ändern möchte) */
  public get navigate(): Subject<Navigationtarget> {
    return this._navigate;
  }

  /** Device ist Online gegangen (wird ausgelöst wenn die App eine Verbindung mit dem Internet aufbaut) */
  public get online(): Subject<void> {
    return this._online;
  }

  // @HostListener("document:offline")
  private listenerOnline(ev: Event) {
    if (this.online) {
      this.online.next();
    }
    console.info("EventsDefault", "listenerOnline", ev);
  }

  /** Device ist Offline gegangen (wird ausgelöst wenn die App eine Verbindung mit dem Internet verliert) */
  public get offline(): Subject<void> {
    return this._offline;
  }

  // @HostListener("document:offline")
  private listenerOffline(ev: Event) {
    if (this.offline) {
      this.offline.next();
    }
    console.info("EventsDefault", "listenerOffline", ev);
  }

  /** yourapp://customer.domain.de ist auferufen worden (wird ausgelöst wenn der Protokoll ausgelöst wird nur Android und iOS) */
  public get externIntent(): Subject<string> {
    return this._externIntent;
  }

  // @HostListener("todo")
  private listenerNavigate(ev: Event) {
    if (this.navigate) {
      this.navigate.next();
    }
  }

  private bindExternIntent() {
    const me = this;
    if (typeof window !== "undefined" && window) {

      if (YourAPPProductType.app_android === environment.producttype) {
        // Android intent
        // This event triggers by opening the app for the first time
        if ((<any>window).plugins && (<any>window).plugins.intent) {
          (<any>window).plugins.intent.getCordovaIntent((intent: any) => {
            me.externIntent.next(intent.data);
          }, (error: any) => {
            me._coreLogService.error("EventsDefault.bindExternIntent", "plugins.intent.getCordovaIntent", error);
          });

          // This event triggers by resuming the app
          (<any>window).plugins.intent.setNewIntentHandler((intent: any) => {
            me.externIntent.next(intent.data);
          }, (error: any) => {
            me._coreLogService.error("EventsDefault.bindExternIntent", "plugins.intent.setNewIntentHandler", error);
          });
        } else {
          me._coreLogService.error("EventsDefault.bindExternIntent", "(<any>window).plugins.intent", "no plugin intent found");
        }
      } else if (YourAPPProductType.app_ios === environment.producttype) {
        // IOS Cordova Custom URL Scheme Handling
        // TODO : https://github.com/apache/cordova-ios/blob/master/guides/Cordova%20Custom%20URL%20Scheme%20Handling.md
        // TODO: https://github.com/EddyVerbruggen/Custom-URL-scheme#manually
        (<any>window).handleOpenURL = (url: string) => {
          me.externIntent.next(url);
        };
      } else {
        if (window.location.search) {
          me.externIntent.next(window.location.href);
        }
      }
    }
  }
}
